import {
  Box,
  Checkbox,
  FormControlLabel,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectAccountCurrency } from "../../../../store/features/accountSlice";
import formatAmount from "../../../../utils/formatAmount";
import { curr } from "../../../../utils/more/currency_country";

const RouteAmountResume = ({
  distance = 0,
  rate = 0,
  loading,
  isFixed = false,
  roundTrip = false,
  onToggleRoundTrip = () => {},
  isEditable = false,
}) => {
  const currency = useSelector(selectAccountCurrency);

  const totalAmount = useMemo(() => {
    if (isFixed) {
      // Rota predefinida: valor fixo do trajeto (x2 quando ida e volta).
      return parseFloat(rate || 0) * (roundTrip ? 2 : 1);
    }
    return parseFloat(distance || 0) * parseFloat(rate || 0);
  }, [rate, distance, isFixed, roundTrip]);

  // Em rotas por km o "ida e volta" já está embutido na distância e o toggle
  // vive no RouteSection. Aqui ele só aparece para rotas predefinidas.
  const showRoundTrip = isFixed && (isEditable || roundTrip);

  return (
    <Box
      position={"absolute"}
      zIndex={100}
      bgcolor={"#FAFBFC"}
      boxShadow={3}
      bottom={0}
      left={0}
      p={3}
      pt={2}
      pb={0}
      width={"25em"}
    >
      <Stack direction={"row"} alignItems={"flex-start"} gap={1}>
        <Box flex={1} minWidth={0}>
          <Typography color="text.secondary" variant="body2" fontWeight={"500"}>
            Valor total
          </Typography>
          <Box height={40}>
            {loading ? (
              <Skeleton height={40} width={150} />
            ) : (
              <Typography variant="h6" fontWeight={"600"}>
                {curr(currency)} {formatAmount(totalAmount)}
              </Typography>
            )}
          </Box>
        </Box>
        {showRoundTrip && !loading && (
          <FormControlLabel
            sx={{ mr: 0 }}
            control={
              <Checkbox
                size="small"
                disabled={!isEditable}
                checked={Boolean(roundTrip)}
                onChange={onToggleRoundTrip}
              />
            }
            label="Ida e volta"
          />
        )}
      </Stack>
    </Box>
  );
};

export default memo(RouteAmountResume);
